import styled from 'styled-components'

export const RecipientWrapper = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: row;

  & > div {
    flex: 1;
  }

  & > div:first-child {
    margin-right: 0;
    max-width: 50%;
  }

  & > svg {
    margin-left: 16px !important;
  }
`
